
import PurchasePurpose from '@/enums/PurchasePurpose';

export default {
  i18nComponentKey: 'ReviewsNew.components.ProductInfo',
  name: 'ProductInfo',
  props: {
    product: { type: Object, required: true },
    subOrder: { type: Object, default: null },
    isEditing: { type: Boolean, required: true },
    bestReviewReward: { type: Number, default: 0 }
  },
  computed: {
    PurchasePurpose: () => PurchasePurpose,
    showPurposeBadge() {
      return (
        !this.isEditing &&
        this.subOrder &&
        this.subOrder.purpose !== PurchasePurpose.NONE
      );
    },
    bestReviewRewardText() {
      return this.$t('best_review_reward', [
        this.formatCurrency(this.bestReviewReward)
      ]);
    },
    purchaseInfo() {
      const values = Object.values(this.subOrder.product_options).filter(
        Boolean
      );

      if (!this.isEditing) {
        const purchasedAt = this.$t('purchased_at', [
          this.formatDate(this.subOrder.purchased_at)
        ]);
        values.push(purchasedAt);
      }

      return values.join(' ∙ ');
    }
  }
};
